import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import removeEmptyKeys from "../../../helpers/removeEmptyKeys";
import { UPDATE_OPTIONAL_MILESTONE_REVISION_REQUEST } from "../types/RequestTypes";
import { appendRevisionToCaseSummaryCache } from "./useGetCaseSummaryQuery";

async function updateOptionalMilestoneRevision(
  reqBody: UPDATE_OPTIONAL_MILESTONE_REVISION_REQUEST
) {
  const body = { ...reqBody };
  delete body.createdAt;
  const { caseId, ...reset } = body;
  return fetcher({
    url: `v2/case/${caseId}/optional-milestone/revision`,
    method: "PATCH",
    data: removeEmptyKeys(reset),
  });
}

export default function useUpdateOptionalMilestoneRevisionMutation() {
  return useMutation({
    mutationFn: updateOptionalMilestoneRevision,
    onSuccess: (_, revision) => {
      appendRevisionToCaseSummaryCache({
        revision,
        isOptionalMilestone: true,
      });
    },
  });
}
